import { v4 as uuidv4 } from 'uuid';
import { types } from '../actions/constFromApi';

const initialState = {
  functionsDirections: [],
  industries: [],
  contractTypes: [],
  filterPeriods: [],
  currencies: null,
  clients: null,
  worktypes: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_CONSTATNTS_REJECTED:
      return { ...state };
    case types.GET_CONSTATNTS_FULFILLED:
      return {
        ...state,
        functionsDirections: [
          { label: 'Function', value: '', key: uuidv4(10) },
          ...action.payload.functionsDirections.map((func) => ({
            label: func.Name,
            value: func.Name,
            key: func.Id,
            JobFunctionId: func.Id
          }))
        ],
        industries: [
          { label: 'Industry', value: '', key: uuidv4(10) },
          ...action.payload.industries.map((industry) => ({
            label: industry.Name,
            value: industry.Name,
            key: industry.Id,
            IndustryId: industry.Id
          }))
        ],
        currencies: [
          ...action.payload.currencies.map((currency) => ({
            label: currency.Currency,
            value: currency.Currency,
            key: currency.Id
          }))
        ],
        contractTypes: [
          { label: 'Contract Type', value: '', key: uuidv4(10) },
          ...action.payload.contractTypes.map((type) => ({
            label: type.TypesName,
            value: type.TypesName?.toLowerCase(),
            key: type.Id
          }))
        ],
        filterPeriods: [
          { label: 'Date Posted', value: '', key: uuidv4(10) },
          ...action.payload.filterPeriods.map((period) => ({
            label: period.DatePosted,
            value: period.Value,
            key: period.Id
          }))
        ],
        clients: [
          ...action.payload.clients.map((client) => ({
            label: client.ClientName,
            value: client.Id,
            key: client.Id
          }))
        ],
        worktypes: [
          ...action.payload.worktypes.map((type) => ({
            label: type.Name,
            value: type.Id,
            key: type.Id
          }))
        ],
        expensetypes: [
          ...action.payload.expensetypes.map((type) => ({
            label: type.Name,
            value: type.Id,
            key: type.Id
          }))
        ]
      };
    case types.GET_PLACEMENTS_CONSTANTS_FULFILLED:
      return {
        ...state,
        placements: [
          ...action.payload.placements.map((placement) => ({
            JobTitle: placement.JobTitle,
            JobId: placement.JobId,
            Id: placement.Id,
            key: placement.Id,
            PoNumber: placement.PoNumber,
            Frequency: placement.Frequency,
            RateType: placement.RateType,
            PayCurrency: placement.PayCurrency
          }))
        ]
      };
    default:
      return state;
  }
}
